import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/footer.scss";

const Footer = () => (
  <footer className="site-footer" role="contentinfo">
    <nav className="site-footer__nav" aria-label="Footer navigation">
      {siteConfig.footerLinks.map((item) => (
        <Link key={item.to} to={item.to}>{item.label}</Link>
      ))}
    </nav>
    <div className="site-footer__content ink-container">
      <div className="site-footer__contact">
        <h2>Customer care</h2>
        <p>{siteConfig.contact.address}</p>
        <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>
      </div>
    </div>
    <div className="site-footer__lower ink-container">
      <p>© {new Date().getFullYear()} {siteConfig.brandName}.</p>
      <div className="site-footer__payments" aria-label="Accepted payment methods">
        {siteConfig.footerPayments.map((method) => (
          <span key={method} title={method}>{method}</span>
        ))}
      </div>
    </div>
  </footer>
);

export default Footer;
